// Copyright: IQGeo Limited 2010-2019
import L from 'leaflet';

// Monkey patch L.Icon to fix an IE specific issue
if (L.Browser.ie) {
    const originalFunction = L.Icon.prototype._createImg;

    L.Icon.prototype._createImg = function(...args) {
        const el = originalFunction.apply(this, args);
        // When img elements are created, IE sometimes adds width and height
        // attributes with values of 0. This prevents the icon being visible.
        // The issue may be limited to elements with SVG source
        el.removeAttribute('width');
        // Check
        el.removeAttribute('height');
        return el;
    };
}
